import React, { useEffect, useState } from "react";
import { API_ciudadanos, API_servicios } from "../../config/apiConfig";
import { toast } from "react-toastify";
import { FaPenToSquare, FaCheck, FaX, FaCirclePlus } from "react-icons/fa6";
import "../../pages/user/css/Curriculum.css";
import { useAuth } from "../../context/AuthContext";

const HistorialSeguimiento = ({ usuario }) => {
  const { token } = useAuth();
  const [historial, setHistorial] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editEntry, setEditEntry] = useState(null);
  const [servicios, setServicios] = useState([]);

  // !Harcoded services was replace with fetch services response
  // const serviciosOpciones = ["SAE", "Andalucía Orienta", "ERACIS", "Punto Vuela", "Servicios Sociales"];

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (!isNaN(date.getTime())) {
      return `${date.getDate().toString().padStart(2, "0")}/${(date.getMonth() + 1).toString().padStart(2, "0")}/${date.getFullYear()}`;
    }
    return dateString;
  };

  useEffect(() => {
    const fetchServicios = async () => {
      try {
        const res = await fetch(API_servicios);
        const data = await res.json();
        const formatteData = data?.map((service) => service.nombre);
        setServicios(formatteData);
      } catch (error) {
        console.error("Error al cargar servicios del ayuntamiento:", error);
      }
    };

    fetchServicios();
  }, []);

  useEffect(() => {
    const obtenerSeguimiento = async () => {
      try {
        const res = await fetch(`${API_ciudadanos}/${usuario.userId}`);
        const data = await res.json();

        const datosOrdenados = [...(data.seguimiento || [])]
          .map((item) => ({
            ...item,
            fecha: formatDate(item.fecha),
          }))
          .sort((a, b) => new Date(b.fecha.split("/").reverse().join("-")) - new Date(a.fecha.split("/").reverse().join("-")));

        setHistorial(datosOrdenados);
      } catch (err) {
        console.error("Error al obtener el historial de seguimiento", err);
        toast.error("No se pudo cargar el historial");
      }
    };

    if (usuario?.userId) obtenerSeguimiento();
  }, [usuario]);

  const handleEdit = (index) => {
    setEditingIndex(index);
    setEditEntry({ ...historial[index] });
  };

  const handleSave = async () => {
    let updatedHistorial;

    if (editingIndex === -1) {
      // Nuevo elemento: añadir al principio para que sea el más reciente
      updatedHistorial = [editEntry, ...historial];
    } else {
      // Elemento editado: mantener posición relativa y luego ordenar
      updatedHistorial = historial.map((item, idx) => (idx === editingIndex ? editEntry : item));
      // Solo reordenar si se editó un elemento existente
      updatedHistorial = [...updatedHistorial].sort(
        (a, b) => new Date(b.fecha.split("/").reverse().join("-")) - new Date(a.fecha.split("/").reverse().join("-"))
      );
    }

    const ordenado = updatedHistorial;

    setHistorial(ordenado);
    setEditingIndex(null);
    setEditEntry(null);

    // Prepara para enviar (usa formato ISO en la fecha)
    const payload = {
      seguimiento: ordenado.map((item) => ({
        ...item,
        fecha: new Date(item.fecha.split("/").reverse().join("-")).toISOString(),
      })),
    };

    try {
      const res = await fetch(`${API_ciudadanos}/${usuario.userId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": token,
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error("Error al guardar el historial");
      toast.success("Historial actualizado correctamente");
    } catch (err) {
      console.error("❌ Error al actualizar historial:", err);
      toast.error("No se pudo guardar el historial");
    }
  };

  const handleCancel = () => {
    setEditingIndex(null);
    setEditEntry(null);
  };

  return (
    <section className="historial caja-verde">
      <div className="titulo-historial between fondo-verde">
        <h2 className="blanco align-center mayusculas">HISTORIAL DE SEGUIMIENTO</h2>
        <button
          aria-label="Añadir nuevo dato"
          className="add-button fondo-verde blanco no-border"
          onClick={() => {
            setEditingIndex(-1);
            setEditEntry({
              fecha: formatDate(new Date().toISOString()),
              servicio: servicios[0],
              asunto: "",
              observaciones: "",
            });
          }}
        >
          <FaCirclePlus />
        </button>
      </div>

      {historial[0] && (
        <p className="ultimo-contacto">
          <span className="bold verde">Último contacto: </span>
          {historial[0].fecha}
        </p>
      )}

      <ul className="contenido">
        <li className="flex titulo verde bold">
          <span className="fecha">FECHA</span>
          <span className="servicio">SERVICIO</span>
          <span className="asunto">ASUNTO</span>
          <span className="observaciones">OBSERVACIONES</span>
        </li>

        {editingIndex !== null && (
          <li className="flex editar-item">
            <input
              type="date"
              value={editEntry.fecha.split("/").reverse().join("-")}
              onChange={(e) =>
                setEditEntry({
                  ...editEntry,
                  fecha: formatDate(e.target.value),
                })
              }
            />
            <select value={editEntry.servicio} onChange={(e) => setEditEntry({ ...editEntry, servicio: e.target.value })}>
              <option value="">Seleccionar servicio...</option>
              {servicios.map((s, i) => (
                <option key={i} value={s}>
                  {s}
                </option>
              ))}
            </select>
            <textarea
              className="asunto"
              value={editEntry.asunto}
              onChange={(e) => setEditEntry({ ...editEntry, asunto: e.target.value })}
            />
            <textarea value={editEntry.observaciones} onChange={(e) => setEditEntry({ ...editEntry, observaciones: e.target.value })} />
            <div className="check flex gap-5">
              <button className="fondo-blanco verde" onClick={handleSave}>
                <FaCheck />
              </button>
              <button className="fondo-blanco rojo" onClick={handleCancel}>
                <FaX />
              </button>
            </div>
          </li>
        )}

        {historial.map((item, index) => (
          <li className="flex" key={index}>
            <span className="fecha">{item.fecha}</span>
            <span className="servicio">{item.servicio}</span>
            <span className="asunto">{item.asunto}</span>
            <span className="observaciones">{item.observaciones}</span>
            <div className="editar">
              <button aria-label="Editar" className="fondo-blanco" onClick={() => handleEdit(index)}>
                <FaPenToSquare />
              </button>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default HistorialSeguimiento;
